export default {
    INTEGER_COMPARE: "IntegerCompare",
    DECIMAL_COMPARE: "DecimalCompare",
    STRING_COMPARE: "StringCompare",
    DATE_COMPARE: "DateCompare",
    REGEX: "RegularExpression",
    SQL: "Sql",
    MASK: "MaskFormatter"
};